import {ApiError} from "./model";

export interface State {
    errorsStack: ApiError[];
}

export const initialState: State = {
    errorsStack: []
}